import { Text } from '~/components/ui/Text';
import { IMessage } from './AppMessengerMessage.model';
import {
	StyledContainer,
	StyledImage,
	StyledMessageContainer,
	StyledNameContainer,
	StyledTextContainer,
} from './AppMessengerMessage.styled';

const AppMessengerMessage = ({
	type,
	player,
	time,
	text,
	online,
}: IMessage) => {
	return (
		<StyledContainer $type={type}>
			<StyledImage $online={online} />
			<StyledMessageContainer $type={type}>
				<StyledNameContainer $type={type} $online={online}>
					<Text className={'name'}>{player}</Text>
					<Text className={'time'}>{time}</Text>
				</StyledNameContainer>
				<StyledTextContainer $type={type}>
					<Text>{text}</Text>
				</StyledTextContainer>
			</StyledMessageContainer>
		</StyledContainer>
	);
};

export { AppMessengerMessage, StyledImage };
